<app-loader [isLoading]="isLoading"></app-loader>
<div class="row mb-4">
  <div class="col-12">
    <div class="col-12 col-top-btn" *ngIf="isPlatformAdmin">
      <button
        type="button"
        (click)="AddEditModalShow(null)"
        class="btn btn-primary"
      >
        <span class="ico-plus-square"></span>
        <span>{{ "tenant.AddTenantTeacher" | translate }}</span>
      </button>
    </div>
  </div>
</div>

<app-list-with-pagination
  [items]="teacherList"
  [itemsPerPage]="searchCriteria.pageSize"
  [totalItems]="totalItems"
  [currentPage]="searchCriteria.pageNumber"
  (pageChange)="onPageChange($event)"
  (edit)="AddEditModalShow($event)"
  (delete)="deleteTenantUsers($event)"
  [showDelete]="isPlatformAdmin"
  (viewDetails)="viewTenantUsersDetails($event)"
  [columns]="tenantuserColumns"
></app-list-with-pagination>

<app-confirm-dialog
  #confirmDialog
  [title]="'app.ConfirmDeletionTitle' | translate"
  [message]="'app.ConfirmDeletionMessage' | translate"
  (confirmed)="onDeleteConfirmed($event)"
>
</app-confirm-dialog>

<div class="custom-modal" [ngClass]="{ show: isDetailsModalShow }">
  <div class="modal-content">
    <div class="modal-content__header">
      <h5>{{ "tenant.TenantUsersDetails" | translate }}</h5>
      <a (click)="closeModal()" class="close"><i class="ico-close"></i></a>
    </div>
    <div class="modal-content__body">
      <div class="img-content">
        <div class="img-profile-details">
          <img src="assets/images/pic4.jpg" />
        </div>
      </div>
      <div class="row g-4">
        <div class="col-lg-6 col-md-6 col-12">
          <div class="item-info-details">
            <span>{{ "tenant.FullName" | translate }}</span>
            <span>{{ selectedtenantusersDto?.teacher?.fullNameEn }}</span>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-12">
          <div class="item-info-details">
            <span>{{ "tenant.EmailAddress" | translate }}</span>
            <span dir="ltr">{{ selectedtenantusersDto?.teacher?.email }}</span>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-12">
          <div class="item-info-details">
            <span>{{ "tenant.DateOfBirth" | translate }}</span>
            <span>{{ formatDob(selectedtenantusersDto?.teacher?.dateOfBirth) }}</span>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-12">
          <div class="item-info-details">
            <span>{{ "tenant.Gender" | translate }}</span>
            <span>{{ selectedtenantusersDto?.teacher?.genderId }}</span>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-12">
          <div class="item-info-details">
            <span>{{ "tenant.PhoneNumber" | translate }}</span>
            <span dir="ltr">{{ selectedtenantusersDto?.teacher?.phoneNumber }}</span>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-12">
          <div class="item-info-details">
            <span>{{ "tenant.Username" | translate }}</span>
            <span dir="ltr">{{ selectedtenantusersDto?.teacher?.userName }}</span>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-12">
          <div class="item-info-details">
            <span>{{ "tenant.TenantName" | translate }}</span>
            <span>{{ selectedtenantusersDto?.tenant?.nameEn }}</span>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-12">
          <div class="item-info-details">
            <span>{{ "tenant.Url" | translate }}</span>
            <span>{{ selectedtenantusersDto?.tenant?.url }}</span>
          </div>
        </div>
      </div>
      <!--End Row-->
    </div>
    <div class="modal-content__footer"></div>
  </div>
</div>

<div class="custom-modal" [ngClass]="{ show: isAddEditModalShow }">
  <div class="modal-content">
    <div class="modal-content__header">
      <h5>{{ "tenant.AddEditTenantUser" | translate }}</h5>
      <a (click)="closeModal()" class="close"><i class="ico-close"></i></a>
    </div>
    <form class="h-100" [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
      <div class="modal-content__body">
        <div class="row g-3">
          <div class="row">
            <!-- Name Arabic -->
            <div class="col-lg-6 col-12">
              <label class="form-label" for="nameAr">{{ "tenant.NameArabic" | translate }}</label>
              <input
                type="text"
                id="nameAr"
                formControlName="nameAr"
                class="form-control"
                [placeholder]="'tenant.EnterArabicName' | translate"
              />
            </div>

            <!-- Name English -->
            <div class="col-lg-6 col-12">
              <label class="form-label" for="nameEn">{{ "tenant.NameEnglish" | translate }}</label>
              <input
                type="text"
                id="nameEn"
                formControlName="nameEn"
                class="form-control"
                [placeholder]="'tenant.EnterEnglishName' | translate"
              />
            </div>

            <!-- URL -->
            <div class="col-lg-6 col-12">
              <label class="form-label" for="url">{{ "tenant.Url" | translate }}</label>
              <input
                type="text"
                id="url"
                formControlName="url"
                class="form-control"
                [placeholder]="'tenant.EnterUrl' | translate"
              />
            </div>

            <!-- Description Arabic -->
            <div class="col-lg-12 col-12">
              <label class="form-label" for="descriptionAr"
                >{{ "tenant.DescriptionArabic" | translate }}</label
              >
              <textarea
                id="descriptionAr"
                formControlName="descriptionAr"
                class="form-control"
                [placeholder]="'tenant.EnterArabicDescription' | translate"
                rows="3"
              ></textarea>
            </div>

            <!-- Description English -->
            <div class="col-lg-12 col-12">
              <label class="form-label" for="descriptionEn"
                >{{ "tenant.DescriptionEnglish" | translate }}</label
              >
              <textarea
                id="descriptionEn"
                formControlName="descriptionEn"
                class="form-control"
                [placeholder]="'tenant.EnterEnglishDescription' | translate"
                rows="3"
              ></textarea>
            </div>
          </div>

          <div class="col-lg-6 col-12">
            <!-- Full Name -->
            <label class="form-label" for="fullNameAr">{{ "student.FullNameAr" | translate }}</label>
            <input
              type="text"
              id="fullNameAr"
              formControlName="fullNameAr"
              class="form-control"
              [placeholder]="'student.EnterFullName' | translate"
            />
          </div>

          <div class="col-lg-6 col-12">
            <!-- Full Name -->
            <label class="form-label" for="fullNameEn">{{ "student.FullNameEn" | translate }}</label>
            <input
              type="text"
              id="fullNameEn"
              formControlName="fullNameEn"
              class="form-control"
              [placeholder]="'student.EnterFullName' | translate"
            />
          </div>

          <div class="col-lg-6 col-12">
            <!-- Email Address -->
            <label class="form-label" for="email">{{ "student.EmailAddress" | translate }}</label>
            <input
              type="email"
              id="email"
              formControlName="email"
              class="form-control"
              [placeholder]="'student.EnterEmail' | translate"
            />
          </div>

          <div class="col-lg-6 col-12">
            <!-- Date of Birth -->
            <label class="form-label" for="dateOfBirth">{{ "student.DateOfBirth" | translate }}</label>
            <input
              type="date"
              id="dateOfBirth"
              formControlName="dateOfBirth"
              class="form-control"
            />
          </div>

          <div class="col-lg-6 col-12">
            <!-- Gender -->
            <label class="form-label" for="genderId">{{ "student.Gender" | translate }}</label>
            <select
              id="genderId"
              formControlName="genderId"
              class="form-control"
            >
              <option value="">{{ "tenant.SelectGender" | translate }}</option>
              <option value="1">{{ "tenant.Male" | translate }}</option>
              <option value="2">{{ "tenant.Female" | translate }}</option>
              <option value="3">{{ "tenant.Other" | translate }}</option>
            </select>
          </div>

          <div class="col-lg-6 col-12">
            <!-- Phone Number -->
            <label class="form-label" for="phoneNumber">{{ "student.PhoneNumber" | translate }}</label>
            <input
              type="text"
              id="phoneNumber"
              formControlName="phoneNumber"
              class="form-control"
              [placeholder]="'student.EnterPhoneNumber' | translate"
            />
          </div>

          <div class="col-lg-6 col-12">
            <!-- Username -->
            <label class="form-label" for="userName">{{ "student.Username" | translate }}</label>
            <input
              type="text"
              id="userName"
              formControlName="userName"
              class="form-control"
              [placeholder]="'student.EnterUsername' | translate"
            />
          </div>

          <div class="col-lg-6 col-12">
            <!-- Gender -->
            <label class="form-label" for="tenantId">{{ "superAdmin.Tenant" | translate }}</label>
            <select
              id="tenantId"
              formControlName="tenantId"
              class="form-control"
            >
              <option value="">{{ "tenant.SelectTenant" | translate }}</option>
              <option value="d73214d5-f621-450f-b8f6-ce629128a3f3">{{ "tenant.Root" | translate }}</option>
            </select>
          </div>

          <div class="col-lg-6 col-12">
            <!-- Password -->
            <label class="form-label" for="password">{{ "tenant.Password" | translate }}</label>
            <input
              type="password"
              id="password"
              formControlName="password"
              class="form-control"
              [placeholder]="'student.EnterPassword' | translate"
            />
          </div>

          <div class="col-lg-6 col-12">
            <!-- Confirm Password -->
            <label class="form-label" for="confirmPassword"
              >{{ "tenant.ConfirmPassword" | translate }}</label
            >
            <input
              type="password"
              id="confirmPassword"
              formControlName="confirmPassword"
              class="form-control"
              [placeholder]="'student.ConfirmYourPassword' | translate"
            />
          </div>
        </div>
        <!-- End Row -->
      </div>

      <div class="modal-content__footer">
        <div class="row">
          <div class="col-12 d-flex justify-content-end">
            <!-- Submit Button -->
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="registrationForm.invalid"
            >
              {{ "app.Register" | translate }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
